export const uniqBy = (arr, getKey) => {
  const seen = new Set()
  const out = []
  ;(arr || []).forEach((item) => {
    if (!item) return
    const key = getKey(item)
    if (!key || seen.has(key)) return
    seen.add(key)
    out.push(item)
  })
  return out
}

export const buildShortcutLinkOptions = ({
  slug,
  dashboards = [],
  incidentBoards = [],
  reports = [],
  paths = {},
  dashboardDetailsMode = 'v2',
}) => {
  const prefix = slug ? `/${slug}` : ''

  const dashboardsPath = paths.dashboardsPath || '/dashboards'
  const incidentsPath = paths.incidentsPath || '/incident'
  const reportsPath = paths.reportsPath || '/reports'

  const dashboardSuffix = dashboardDetailsMode === 'v2' ? '/v2' : ''

  const dashboardOptions = (dashboards || [])
    .filter((d) => d && (d._id || d.id) && d.name)
    .map((d) => {
      const id = d._id || d.id
      return {
        label: d.name,
        value: `${prefix}${dashboardsPath}/${id}${dashboardSuffix}`,
        category: 'dashboards',
      }
    })

  const incidentBoardOptions = (incidentBoards || [])
    .filter((b) => b && (b._id || b.id) && b.name)
    .map((b) => {
      const id = b._id || b.id
      return {
        label: b.name,
        value: `${prefix}${incidentsPath}/${id}`,
        category: 'incidents',
      }
    })

  const reportOptions = (reports || [])
    .filter((r) => r && (r._id || r.id) && r.name)
    .map((r) => {
      const id = r._id || r.id
      return {
        label: r.name,
        value: `${prefix}${reportsPath}/${id}`,
        category: 'reports',
      }
    })

  return uniqBy(
    [...dashboardOptions, ...incidentBoardOptions, ...reportOptions],
    (o) => o.value,
  )
}
